export const modal = {
  confirm: 'Подтвердите действие',
  confirm_content: 'Вы действительно хотите удалить запись #{id}?',
  edit: 'Редактировать запись',
  create: 'Добавить запись',
  export: 'Экспорт статистики',
  create_recording: 'Создать архив записей',
  warning: 'Внимание',
  add_ip: 'Добавить IP',

  field: {
    search: {
      placeholder: '@:shared.component.filter.search'
    }
  },

  confirmation: {
    recording: 'Вы уверены, что хотите экспортировать записи?'
  }
};
